import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import throttle from 'lodash/throttle';

import { Sticky as Component } from './sticky';
import type { IDeps, TSticky } from './models';
import styles from './styles/styles.css';

// Пропсы прокидываются на корневой элемент через переменную classNames
// eslint-disable-next-line styler/check-styler
export const Sticky = createWidget<IDeps, TSticky>({
    styles,
    throttle,
})(Component);
